import { Component, input, output } from '@angular/core';
import {
  BatchUploadConfig,
  BatchUploadModalComponent,
} from '@shared/components/batch-upload-modal/batch-upload-modal.component';

@Component({
  selector: 'app-batch-upload-unit-name',
  imports: [BatchUploadModalComponent],
  template: `
    <app-batch-upload-modal
      [isVisible]="isVisible()"
      [config]="uploadConfig"
      (isVisibleChange)="isVisibleChange.emit($event)"
    ></app-batch-upload-modal>
  `,
})
export class BatchUploadUnitNameComponent {
  readonly isVisible = input<boolean>(false);
  readonly isVisibleChange = output<boolean>();

  uploadConfig: BatchUploadConfig = {
    title: '批量修改单元名称',
    templateUrl:
      'https://static-cdn.linkworld.cn/xiaohong/红品智-推广-批量修改单元名称模板_2026-11-04.xlsx',
    type: 21,
    description: '1、下载批量修改单元名称模板，批量填写单元名称信息',
  };
}
